
import VacancyCard from '@/components/vacancies/VacancyCard.vue';
import VacancyCardPopup from '@/components/vacancies/VacancyCardPopup.vue';

export default {
  fetch: async function () {
    await this.getVacancies();
  },

  data() {
    return {
      isShowVacancyPopup: false,
      vacancyForPopup: {},
      vacancies: [],
    }
  },

  computed: {
    cmsPageId: function () {
      const _id = this.$store.state.appState?.vars?.['CMS PAGE ID страницы вакансии'];
      if (!_id) {
        return
      }
      return Number.parseFloat(_id)
    },
  },

  components: {
    VacancyCard,
    VacancyCardPopup,
  },

  methods: {
    openPopup(vacancy) {
      const body = document.querySelector('body')
      body.classList.add('stop-scroll')
      this.isShowVacancyPopup = true
      this.vacancyForPopup = {...vacancy}
    },
    closePopup() {
      const body = document.querySelector('body')
      body.classList.remove('stop-scroll')
      this.isShowVacancyPopup = false
    },
    getVacancies: async function () {
      const responseVacancies = await this.$api.transport.get(`/vacancy`)
      .then((res) => {
        return res.data
      }).catch(() => {
        return []
      })
      this.vacancies = responseVacancies.filter((item) => item.status !== 0);
    },
  },
}
